/* eslint-disable multiline-ternary */
import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Dropdown, Card,  ListGroup } from 'react-bootstrap'
import { FilterSearchBar } from '../FilterSearchBar/FilterSearchBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faFolderOpen, faFolderMinus } from '@fortawesome/free-solid-svg-icons';
import * as Logger from 'loglevel'
import './styles.module.scss'


export function FolderTreeSelector(props) {

    const [openNodes, setOpenNodes] = useState([]);
    const [selected, setSelected] = useState([]);
    const [isShow, setIsShow ] = useState(false);
    const [filterText, setFilterText ] = useState('');
    const wrapperRef = useRef(null);


    useEffect(() => {
      const handleClickOutside = event => {
        if (isShow && !!wrapperRef.current) {
          if (!wrapperRef.current.contains(event.target)) {
            setIsShow(false);
          }
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isShow, wrapperRef, setIsShow]);

    const selectAllFilters = () => {
        props.setSelectedVals(props.availableVals, props.id)
    }

    const flushFilters = () => {
        props.setSelectedVals([], props.id)
      }

    const handleOnClickIsShow = () => {
        setIsShow(!isShow);
    }

    const setFilterSearchText = (newText) => {
        setFilterText(newText);
      }


    const toggleNode = (nodeId) => {
        if (openNodes.includes(nodeId)){
            setOpenNodes(openNodes.filter((id) => id !== nodeId));
        } else {
            setOpenNodes([...openNodes, nodeId]);
        }
    }

    const handleNodeSelect = (node) => {

      Logger.debug(node)
      const foundFilterObj = selected.find((toFilter) => toFilter.id === node.id)
      let newFilterArr = [] // initialize black array then concat to prevent state mutation
      newFilterArr = newFilterArr.concat(props.selectedVals)
      Logger.debug(newFilterArr)
      if (foundFilterObj) {
        // if checked object is already in the filter, remove it
        newFilterArr = newFilterArr.filter((filteredObj) => filteredObj !== foundFilterObj)

      } else {
        // if checked object is not in the filter, add it
        newFilterArr.push(node)
      }
        
        setSelected([...selected, node]);
        Logger.debug(newFilterArr);
        props.setSelectedVals(newFilterArr, props.id);
    }

    const TreeNode = ({node}) => {
        const hasChildren = !!node.nodes && node.nodes.length > 0;
        const isOpen = openNodes.includes(node.id);
        const backgroundColor = selected.includes(node.id) ? '#f69b1d' : 'none';

        return (
            <ListGroup.Item 
                className="listGroupItem"
                as='li'
                onClick={!!hasChildren ? undefined : () => handleNodeSelect(node)}
                style={{ backgroundColor: backgroundColor + '!important' }}
            >
                {!!hasChildren ? (
                    <span
                        className="node-toggle"
                        onClick={(event)=>{
                            event.stopPropagation();
                            toggleNode(node.id)
                        }}
                    >
                        {isOpen? <FontAwesomeIcon icon={faFolderMinus} /> : <FontAwesomeIcon icon={faFolderOpen} /> }
                         {node.text}
                    </span>
                ): <span > <FontAwesomeIcon icon={faFolderMinus} />  {node.text} </span> }
                        
                        {isOpen && (
                            <ListGroup as="ul" className="listGroup" style={{backgroundColor:'none !important'}} >
                                {node.nodes.map((childNode) => (
                                    <TreeNode key={childNode.id} node={childNode} />
                                ))}
                            </ListGroup>
                        )}
            </ListGroup.Item>
        )
    }

    return (
        <Dropdown
        className='filterDropdown'
        show={isShow}
        ref={wrapperRef}
      >
        <Dropdown.Toggle
          className={`filterDropdownToggle ${
            !!props.selectedVals && props.selectedVals.length === 0 ? 'InActive ' : ''
          }`}
          onClick={() => handleOnClickIsShow()}
          id='dropdown-basic'
        >
          <FontAwesomeIcon icon={props.toggleIcon} />
          {' ' + props.title}
          <div className='filterCountDisplay'>
            <span className='filterCount'>
              {!!props.selectedVals ? props.selectedVals.length : 0}
            </span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className='filterDropdownMenu'>
          { isShow ? (
            <Card className='filterDropdownCard' style={{width: '175%'}}>
              <Card.Body>
                <Row>
                  <Col xs='12'>
                    <FilterSearchBar
                      setSearchText={(newText) =>
                        setFilterSearchText(newText)
                      }
                      searchText={filterText}
                    />
                  </Col>
                </Row> 
                <Row> 
                  <Col xs='12' className='filterFolderContainer'>
                    <ListGroup className="listGroup" style={{backgroundColor:'none !important'}} >
                        {props.availableVals.map((node)=>(
                            <TreeNode key={node.id} node={node} />
                        ))}
                    </ListGroup>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ) : (
            <div />
          )}
        </Dropdown.Menu>
      </Dropdown>
        
    )
}
